import dynamic from 'next/dynamic';

export type { IYoutubePlayerRef } from './youtube-player';

export const YoutubePlayer = dynamic(() => import('./youtube-player'), { ssr: false });
